<div class="modal-content">
  <div class="header">
    Edit discover
    <div class="close" (click)="close()">
      <i class="fa fa-times"></i>
    </div>
  </div>
  <div class="content">
    <div class="info">
      <h4>Information</h4>
      <div class="form">
        <div class="form-group">
          <div class="label">Titre Fr</div>
          <input type="text" required id="titleFr" [(ngModel)]="discoverModel.titleFr" #titleFr="ngModel" />
          <div *ngIf="titleFr.invalid && (titleFr.dirty || titleFr.touched)">
            Title Fr is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Titre En</div>
          <input type="text" required id="titleEn" [(ngModel)]="discoverModel.titleEn" #titleEn="ngModel" />
          <div *ngIf="titleEn.invalid && (titleEn.dirty || titleEn.touched)">
            Title En is required
          </div>
        </div>
        <div class="form-group">
          <label for="distance">Distance</label>
          <input type="text" id="distance" [(ngModel)]="discoverModel.distance" name="distance" #distance="ngModel" />
        </div>
        <div class="form-group">
          <label for="duration">Durée à pied</label>
          <input type="text" id="duration" [(ngModel)]="discoverModel.duration" name="duration" #duration="ngModel" />
        </div>
        <div class="form-group">
          <label for="distanceDuration">Durée en voiture</label>
          <input type="text" id="distanceDuration" [(ngModel)]="discoverModel.distanceDuration" name="distanceDuration"
            #distanceDuration="ngModel" />
        </div>
        <div class="form-group">
          <label for="descriptionFr">Description Fr</label>
          <textarea rows="10" required id="descriptionFr" [(ngModel)]="discoverModel.descriptionFr" name="descriptionFr"
            #descriptionFr="ngModel"></textarea>
          <div *ngIf="descriptionFr.invalid && (descriptionFr.dirty || descriptionFr.touched)">
            Description is required
          </div>
        </div>
        <div class="form-group">
          <label for="descriptionEn">Description En</label>
          <textarea rows="10" required id="descriptionEn" [(ngModel)]="discoverModel.descriptionEn" name="descriptionEn"
            #descriptionEn="ngModel"></textarea>
          <div *ngIf="descriptionEn.invalid && (descriptionEn.dirty || descriptionEn.touched)">
            Description is required
          </div>
        </div>
        <div class="form-group">
          <label for="umapUrlFr">Umap link Fr</label>
          <textarea rows="3" required id="umapUrlFr" [(ngModel)]="discoverModel.umapUrlFr" name="umapUrlFr"
            #umapUrlFr="ngModel"></textarea>
          <div *ngIf="umapUrlFr.invalid && (umapUrlFr.dirty || umapUrlFr.touched)">
            Umap is required
          </div>
        </div>
        <div class="form-group">
          <label for="umapUrlEn">Umap link En</label>
          <textarea rows="3" required id="umapUrlEn" [(ngModel)]="discoverModel.umapUrlEn" name="umapUrlEn"
            #umapUrlEn="ngModel"></textarea>
          <div *ngIf="umapUrlEn.invalid && (umapUrlEn.dirty || umapUrlEn.touched)">
            Umap is required
          </div>
        </div>
        <div class="form-group">
          <label for="gpxUrl">GPX Url</label>
          <input type="text" id="gpxUrl" [(ngModel)]="discoverModel.gpxUrl" name="gpxUrl" #gpxUrl="ngModel" />
        </div>
        <div class="form-group">
          <label for="videoUrl">Video URL</label>
          <input type="text" id="videoUrl" [(ngModel)]="discoverModel.videoUrl" name="videoUrl" #videoUrl="ngModel" />
        </div>
      </div>
    </div>
    <div class="pictures">
      <h4>Pictures</h4>
      <div class="form">
        <div class="form-group">
          <input type="file" (change)="onFileChange($event)" multiple>
        </div>
      </div>
      <div class="files">
        <div class="file" *ngFor="let picture of discoverModel.pictures">
          <input type="number" [(ngModel)]="picture.order" (change)="pictureChange(picture)" />
          <div class="file-name" *ngIf="picture.file">
            {{picture.file.name}}
          </div>
          <div class="file-name" *ngIf="discoverModel.id && !picture.file">
            {{getPictureName(picture.path)}}
          </div>
          <div class="icon" (click)="removePictureFromDiscover(picture)">
            <i class="fa fa-times"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <button class="wire-btn" (click)="saveDiscover()">Save</button>
    <button class="wire-btn default" (click)="close()">Cancel</button>
  </div>
</div>